import { render, staticRenderFns } from "./Providers-table.vue?vue&type=template&id=2caa0abe&scoped=true"
import script from "./Providers-table.vue?vue&type=script&lang=js"
export * from "./Providers-table.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Providers-table.vue?vue&type=style&index=1&id=2caa0abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caa0abe",
  null
  
)

export default component.exports